export default {
      id: "close-usage",
      viewBox: "0 0 450 450",
      url: __webpack_public_path__ + "img/icons.a13474e0.svg#close",
      toString: function () {
        return this.url;
      }
    }